import { useStyle } from '@/classify';
import { usePassword } from '@/hooks/Password/usePassword';

import { isRequired } from '@/util/formValidators';
import Image from 'next/image';
import Button from '../Button';
import Field from '../Field';
import TextInput from '../TextInput';
import defaultClasses from './password.module.css';

const Password = props => {
  const {
    classes: propClasses,
    label,
    fieldName,
    isToggleButtonHidden = true,
    autoComplete,
    validate = isRequired,
    required,
    icon,
    ...otherProps
  } = props;

  const talonProps = usePassword();
  const { handleBlur, togglePasswordVisibility, visible } = talonProps;
  const classes = useStyle(defaultClasses, propClasses);

  const passwordButton = (
    <Button
      className={classes.passwordButton}
      onClick={togglePasswordVisibility}
      type='button'
    >
      {/* {visible ? <Eye /> : <EyeOff />} */}
      {visible ? (
        <Image
          src='/icons/eye.svg'
          alt='eye-on'
          width={24}
          height={18}
        />
      ) : (
        <Image
          src='/icons/eyeOff.svg'
          alt='eye-off'
          width={24}
          height={18}
        />
      )}
    </Button>
  );

  const fieldType = visible ? 'text' : 'password';

  return (
    <Field
      id='Password'
      label={label}
      classes={{
        root: classes.root,
      }}
      required={required}
      icon={icon}
    >
      <TextInput
        after={!isToggleButtonHidden && passwordButton}
        autoComplete={autoComplete}
        field={fieldName}
        type={fieldType}
        validate={validate}
        onBlur={handleBlur}
        {...otherProps}
      />
    </Field>
  );
};

export default Password;
